import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { isEmptyList } from '../../utils'
import HotSwapDashboardTable from './components/hot-swap-dashboard-table'
import HotSwapDashboardSearch from './components/hot-swap-dashboard-search'
import * as actions from './actions'
import CustomButton from '../root/components/common/button'
import {
    urlToSearchState,
    useSyncUrlState
} from 'web/src/utils/hooks/useSyncUrlState'
import { useHotswapFilters } from '../root/hooks/use-hotswap-filters'
import HotSwapLoader from './components/hot-swap-loader'
import HotSwapEmptyListMessage from './components/hot-swap-empty-list-message'

export default function HotSwapDashboard() {
    const classes = useStyles()
    const loc = useLocation()
    const [filters, d] = useHotswapFilters(urlToSearchState(loc))
    useSyncUrlState(filters)
    const history = useHistory()

    const { locale } = useSelector(state => state.main)
    const { locations, isLoading } = useSelector(state => state.hotswap)

    const [selectedLocations, setSelectedLocations] = useState([])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(actions.getLocationsRequest(filters))
    }, [filters])

    const onSearch = searchValue => {
        d({ type: 'search', value: searchValue.trim() })
    }

    const handleHotSwapStart = selectedLocations => {
        const locationsArray = Array.isArray(selectedLocations)
            ? selectedLocations
            : typeof selectedLocations === 'object' &&
              selectedLocations !== null
            ? [selectedLocations]
            : []
        dispatch(actions.setSelectedHotSwapLocations(locationsArray))
        history.push(`/hot-swap/start`)
    }

    return (
        <div className={classes.wrapper}>
            <div className={classes.toolbarWrapper}>
                {selectedLocations.length > 1 && (
                    <CustomButton
                        className={classes.btn}
                        onClick={() => {
                            handleHotSwapStart(selectedLocations)
                        }}>
                        {locale.hotSwap.startHotSwap}
                    </CustomButton>
                )}
                <div className={classes.searchWrapper}>
                    <HotSwapDashboardSearch
                        locale={locale}
                        onSearch={onSearch}
                        filters={filters}
                    />
                </div>
            </div>
            <HotSwapLoader list={locations} isLoading={isLoading} />
            <HotSwapEmptyListMessage list={locations} isLoading={isLoading} />

            {!isEmptyList(locations) && !isLoading && (
                <div style={{ flex: 1 }}>
                    <HotSwapDashboardTable
                        hotSwapLocations={locations}
                        showAssignmentColumn
                        search={filters.search}
                        isLoading={isLoading}
                        handleHotSwapStart={handleHotSwapStart}
                        selectedLocations={selectedLocations}
                        setSelectedLocations={setSelectedLocations}
                        sorting={filters.sort_by}
                        onSort={sort_by => d({ type: 'sort', sort_by })}
                    />
                </div>
            )}
        </div>
    )
}

const useStyles = makeStyles(() => ({
    wrapper: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    btn: {
        width: 180,
        height: 'auto'
    },
    toolbarWrapper: {
        display: 'flex',
        marginBottom: '20px',
        alignSelf: 'flex-end',
        gap: 16
    },
    searchWrapper: {
        maxWidth: 260
    }
}))
